import { createFileRoute } from "@tanstack/react-router";
import SpravatoHighFunctioning from "@/pages/SpravatoHighFunctioning";
export const Route = createFileRoute(
  "/spravato-for-high-functioning-depression",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "SPRAVATO® for High-Functioning Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "High-functioning depression treatment with SPRAVATO® at Neuro Wellness in Coral Springs, FL. Esketamine for depression that persists despite functioning.",
        },
        {
          property: "og:title",
          content:
            "SPRAVATO® for High-Functioning Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "High-functioning depression treatment with SPRAVATO® at Neuro Wellness in Coral Springs, FL. Esketamine for depression that persists despite functioning.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/spravato-for-high-functioning-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-for-high-functioning-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoHighFunctioning />;
}
